import { z } from "zod";

export const contactFormSchema = z.object({
  name: z
    .string()
    .min(1, { message: "required" })
    .max(50, { message: "large" }),
  email: z
    .string()
    .min(1, { message: "required" })
    .max(260, { message: "large" })
    .email({ message: "invalid" }),
  mobile: z
    .string()
    .min(1, { message: "required" })
    .length(9, { message: "invalid" }),
  message: z
    .string()
    .min(1, { message: "required" })
    .max(500, { message: "large" }),
});

export type ContactFormSchema = z.infer<typeof contactFormSchema>;

export const contactFormDefaultValue: ContactFormSchema = {
  name: "",
  email: "",
  mobile: "",
  message: "",
};

export const getContactFormError = (
  errors: any,
  mobileValue: string
): string => {
  if (
    errors.name?.message === "required" ||
    errors.email?.message === "required" ||
    errors.message?.message === "required" ||
    errors.mobile?.message === "required"
  ) {
    return "Please fill all the fields to send a message";
  }

  if (
    errors.email?.message === "invalid" ||
    errors.email?.message === "large"
  ) {
    return "Invalid Email";
  }

  if (errors.name?.message === "large") {
    return "Name should contain less than 50 characters";
  }

  if (errors.mobile?.message === "invalid" || /\D/.test(mobileValue)) {
    return "Invalid mobile";
  }

  if (errors.message?.message === "large") {
    return "Message should contain less than 500 characters";
  }

  return "";
};
